import { CardDetails, lazyParseCardFromStringOrObject } from 'owa-actionable-message-v2';
import { trace } from 'owa-trace';

const DEFAULT_CONNECTOR_SENDER_GUID = '00000000-0000-0000-0000-000000000000';
const HIGHLIGHT_PREFIX: string = 'Highlight_';

export default async function parseCardProperty(cardProperty: string): Promise<CardDetails[]> {
    let cardData;
    try {
        cardData = JSON.parse(cardProperty);
    } catch (ex) {
        throw new Error(
            '[ActionableMessageCard] parseCardProperty: unable to parse card data: ' + cardProperty
        );
    }

    // Get the global properties
    const commonProps = {
        connectorSenderGuid: cardData.ConnectorSenderGuid
            ? cardData.ConnectorSenderGuid
            : DEFAULT_CONNECTOR_SENDER_GUID,
        smtpAddressesSerialized: cardData.SmtpAddressesSerialized,
        providerAccountUniqueId: cardData.ProviderAccountUniqueId,
        messageCardExtensionContext: cardData.MessageCardExtensionContext,
    };

    const cardDetails: CardDetails[] = [];
    if (cardData.AdaptiveCardSerialized) {
        cardDetails.push(
            await lazyParseCardFromStringOrObject
                .import()
                .then(parseCard =>
                    parseCard(
                        commonProps,
                        cardData.AdaptiveCardSerialized,
                        cardData.AdaptiveCardSignature,
                        true
                    )
                )
        );
    } else if (cardData.MessageCardSerialized) {
        cardDetails.push(
            await lazyParseCardFromStringOrObject
                .import()
                .then(parseCard =>
                    parseCard(
                        commonProps,
                        cardData.MessageCardSerialized,
                        cardData.MessageCardSignature,
                        false
                    )
                )
        );
    } else {
        trace.info('[ActionableMessageCard] parseCardProperty: No serialized card present');
        return [];
    }

    return cardDetails.concat(await parseHighlightsSerialized(cardData, commonProps));
}

async function parseHighlightsSerialized(
    cardData: object,
    commonProps: any
): Promise<CardDetails[]> {
    const cardDetails: CardDetails[] = [];

    await Promise.all(
        Object.keys(cardData).map(
            async (key: string): Promise<void> => {
                if (cardData.hasOwnProperty(key) && key.indexOf(HIGHLIGHT_PREFIX) === 0) {
                    const highlightSerialized = cardData[key];
                    try {
                        const highlightJson = JSON.parse(highlightSerialized);
                        const card = await lazyParseCardFromStringOrObject
                            .import()
                            .then(parseCard => parseCard(commonProps, highlightJson.card, null));
                        card.isContextual = true;
                        card.key = highlightJson.id;
                        card.highlightTerm = highlightJson.text;
                        cardDetails.push(card);
                    } catch (ex) {
                        trace.warn(
                            '[ActionableMessageDebug] RenderCard: unable to render hightlight card: ' +
                                ex.message
                        );
                    }
                }
            }
        )
    );

    return cardDetails;
}
